// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.boostads.RentalManagerUserPropertyBoostAdsWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyBoostAdsWebApiHandler_getBoostListingDetails,
  RentalManagerUserPropertyBoostAdsWebApiHandler_getBoostListingDetails_Path,
  RentalManagerUserPropertyBoostAdsWebApiHandler_getListingHousingFlagTypes,
  RentalManagerUserPropertyBoostAdsWebApiHandler_getListingHousingFlagTypes_Path,
  RentalManagerUserPropertyBoostAdsWebApiHandler_updateBoostListingDetails,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  BoostAdConfigDetailsDto,
  BoostAdFlagType,
  ListingAlias,
  RentalManagerUpdateBoostListingDetailsRequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface GetBoostListingDetailsParams {
  customerId: string;
  listingAlias: ListingAlias;
}
interface GetListingHousingFlagTypesParams {
  listingAlias: ListingAlias;
}

export type RentalManagerUserPropertyBoostAdsWebApiHandler_getBoostListingDetails_Options = UseQueryOptions<
  BoostAdConfigDetailsDto,
  unknown,
  BoostAdConfigDetailsDto,
  readonly [string, GetBoostListingDetailsParams]
>;

const RentalManagerUserPropertyBoostAdsWebApiHandler_getBoostListingDetails_GetKey = (
  getParams: GetBoostListingDetailsParams,
) => [RentalManagerUserPropertyBoostAdsWebApiHandler_getBoostListingDetails_Path, getParams] as const;

export const RentalManagerUserPropertyBoostAdsWebApiHandler_getBoostListingDetails_queryOptions = (
  getParams: GetBoostListingDetailsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyBoostAdsWebApiHandler_getBoostListingDetails_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyBoostAdsWebApiHandler_getBoostListingDetails(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get boost ad config by listing alias
 */
export const useRentalManagerUserPropertyBoostAdsWebApiHandler_getBoostListingDetails = (
  getParams: GetBoostListingDetailsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyBoostAdsWebApiHandler_getBoostListingDetails_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyBoostAdsWebApiHandler_getBoostListingDetails_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyBoostAdsWebApiHandler_getBoostListingDetails.getKey =
  RentalManagerUserPropertyBoostAdsWebApiHandler_getBoostListingDetails_GetKey;

export type RentalManagerUserPropertyBoostAdsWebApiHandler_getListingHousingFlagTypes_Options = UseQueryOptions<
  Array<BoostAdFlagType>,
  unknown,
  Array<BoostAdFlagType>,
  readonly [string, GetListingHousingFlagTypesParams]
>;

const RentalManagerUserPropertyBoostAdsWebApiHandler_getListingHousingFlagTypes_GetKey = (
  getParams: GetListingHousingFlagTypesParams,
) => [RentalManagerUserPropertyBoostAdsWebApiHandler_getListingHousingFlagTypes_Path, getParams] as const;

export const RentalManagerUserPropertyBoostAdsWebApiHandler_getListingHousingFlagTypes_queryOptions = (
  getParams: GetListingHousingFlagTypesParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyBoostAdsWebApiHandler_getListingHousingFlagTypes_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyBoostAdsWebApiHandler_getListingHousingFlagTypes(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get Listing Housing Flag Types
 */
export const useRentalManagerUserPropertyBoostAdsWebApiHandler_getListingHousingFlagTypes = (
  getParams: GetListingHousingFlagTypesParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyBoostAdsWebApiHandler_getListingHousingFlagTypes_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyBoostAdsWebApiHandler_getListingHousingFlagTypes_queryOptions(getParams, {
      httpClient,
    }),
    ...options,
  });
};
useRentalManagerUserPropertyBoostAdsWebApiHandler_getListingHousingFlagTypes.getKey =
  RentalManagerUserPropertyBoostAdsWebApiHandler_getListingHousingFlagTypes_GetKey;

export interface RentalManagerUserPropertyBoostAdsWebApiHandler_updateBoostListingDetails_Args {
  postData: RentalManagerUpdateBoostListingDetailsRequestDto;
}

export type RentalManagerUserPropertyBoostAdsWebApiHandler_updateBoostListingDetails_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyBoostAdsWebApiHandler_updateBoostListingDetails_Args
>;

/**
 * Update boost ad for listing
 */
export const useRentalManagerUserPropertyBoostAdsWebApiHandler_updateBoostListingDetails = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyBoostAdsWebApiHandler_updateBoostListingDetails_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyBoostAdsWebApiHandler_updateBoostListingDetails_Args) =>
      RentalManagerUserPropertyBoostAdsWebApiHandler_updateBoostListingDetails(args.postData, httpClient),
  });
};
